import { render, staticRenderFns } from "./NotifyCustomerDialog.vue?vue&type=template&id=3edf964b&scoped=true"
import script from "./NotifyCustomerDialog.vue?vue&type=script&lang=js"
export * from "./NotifyCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf964b",
  null
  
)

export default component.exports